export default "__VITE_ASSET__BNSP1xRX__"